import { DeviceLocationEnum } from '@modules/digital-signage/model/devices.model';
import { DeviceGroupOption } from '@modules/digital-signage/model/device-groups.model';
import { MoveDevicesToGroupReqModel } from '@models/digital-signage/device-groups.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import { CallStateMethods } from '@shared/store-features/call-state-feature';

export interface DeviceActionParams {
  data?: any;
  id?: any;
  state?: any;
  handleClose?: () => void;
}

export interface MoveDevicesToGroupParams {
  body: MoveDevicesToGroupReqModel;
  state: any;
  handleClose?: () => void;
}

export interface DeviceState extends CallStateMethods {
  callState: CallStateEnum;
  optionsCallState: CallStateEnum;
  deviceGroupsData: DeviceGroupOption[];
  getDeviceGroupsOptions: () => void;
  reloadDevices: (
    body: { ids: string[]; deviceLocation: DeviceLocationEnum },
    onSuccess?: () => void
  ) => void;
  deleteRow: (params: {
    data: { ids: string[]; deviceLocation: DeviceLocationEnum };
    state: any;
    handleClose?: () => void;
  }) => void;
  activateDeviceWithCode: (params: DeviceActionParams) => void;
  moveDevicesToGroup: (params: MoveDevicesToGroupParams) => void;
  isOptionsLoading: () => boolean;
}

interface DeviceStateMethods {
  reloadDevices: 'reloadDevices';
  getDeviceGroupsOptions: 'getDeviceGroupsOptions';
  deleteRow: 'deleteRow';
  activateDeviceWithCode: 'activateDeviceWithCode';
  moveDevicesToGroup: 'moveDevicesToGroup';
  isOptionsLoading: 'isOptionsLoading';
}

export const DEVICES_INITIAL_STATE: Omit<
  DeviceStateMethods,
  keyof DeviceState
> = {
  deviceGroupsData: [],
  callState: CallStateEnum.Init,
  optionsCallState: CallStateEnum.Init
};
